import { render, staticRenderFns } from "./ReportPayment.vue?vue&type=template&id=a4dc5046&scoped=true&"
import script from "./ReportPayment.vue?vue&type=script&lang=ts&"
export * from "./ReportPayment.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPayment.vue?vue&type=style&index=0&id=a4dc5046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc5046",
  null
  
)

export default component.exports